import { Component, OnInit, Input } from "@angular/core";
import { MessageType } from "@schema/message";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import { faCheck, faInfoCircle, faExclamationTriangle, faTimes } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-error-message",
  templateUrl: "./error-message.component.html",
  styleUrls: ["./error-message.component.scss"]
})
export class ErrorMessageComponent implements OnInit {

  @Input()
  public error = "";

  @Input()
  public errorType: MessageType;

  get alertClass(): string {
    let className = "info";
    switch (this.errorType) {
      case MessageType.ERROR:
        className = "danger";
        break;
      case MessageType.SUCCESS:
      case MessageType.INFO:
      case MessageType.WARNING:
      default:
        className = this.errorType;
    }
    return `alert-${className}`;
  }

  get icon(): IconDefinition {
    switch (this.errorType) {
      case MessageType.SUCCESS:
        return faCheck;
      case MessageType.INFO:
        return faInfoCircle;
      case MessageType.WARNING:
        return faExclamationTriangle;
      case MessageType.ERROR:
        return faTimes;
    }
  }

  constructor() { }

  ngOnInit(): void { }

}
